import fetcher from '@/utils/fetcher';

interface IPutUserChangePassword {
  prePassword: string;
  password: string;
}

async function putUserChangePassword(data: IPutUserChangePassword) {
  try {
    const res = await fetcher.put('/api/profile/password', {
      data,
    });

    return '';
  } catch (e: any) {
    const message = e.response?.data?.error?.message;
    if (message === 'the password does not match') {
      return '현재 비밀번호가 올바르지 않습니다.';
    }
    return '서버에서 오류가 발생했습니다.';
  }
}

export default putUserChangePassword;
